import { BODY_FONT, DISPLAY_FONT } from "./colors";

// Fixed rem sizes (no viewport units): headings in Bricolage Grotesque, body in
// Public Sans. Both fonts are loaded in public/index.html.
const display = { fontFamily: DISPLAY_FONT, fontWeight: 800, letterSpacing: "-0.03em", lineHeight: 1.15 };

export const typographyTheme = {
  fontFamily: BODY_FONT,
  h1: { ...display, fontSize: "2.25rem" },
  h2: { ...display, fontSize: "1.875rem" },
  h3: { ...display, fontSize: "1.5rem" },
  h4: { ...display, fontSize: "1.625rem" },
  h5: { ...display, fontSize: "1.25rem" },
  h6: { ...display, fontSize: "1.0625rem" },
  subtitle1: { fontSize: "0.875rem", fontWeight: 600 },
  subtitle2: { fontSize: "0.8125rem", fontWeight: 600 },
  body1: { fontSize: "0.90625rem", lineHeight: 1.5 },
  body2: { fontSize: "0.84375rem", lineHeight: 1.45 },
  caption: { fontSize: "0.75rem", lineHeight: 1.4 },
  overline: { fontSize: "0.6875rem", fontWeight: 700, letterSpacing: "0.08em", lineHeight: 1.6 },
  button: { fontSize: "0.875rem", fontWeight: 700, textTransform: "none" as const },
};
